import React from "react";

import Layout from "../containers/layout";
import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import PageContainer from "../components/pageContainer";
import UltherapyMain from "../components/ultherapyMain";

const Ultherapy = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const magazinPreview = data && data?.magazinPreview?.nodes;
  const allServices = data && data?.allServices?.nodes;
  const tags = data && data?.tags?.nodes;

  return (
    <Layout services={allServices} tags={tags} magazin={magazinPreview}>
      <SEO
        title={"Ultherapy® Prime – Lifting bez skalpelu"}
        description={
          "Ultherapy® Prime – jediné neinvazivní ošetření s FDA certifikací pro lifting a zpevnění pleti pomocí mikro fokusovaného ultrazvuku."
        }
        keywords={[
          "Ultherapy",
          "Prime",
          "lifting",
          "neinvazivní",
          "ultrazvuk",
          "HIFU",
          "facelift",
          "zpevnění pleti",
        ]}
      />
      <PageContainer>
        <UltherapyMain />
      </PageContainer>
    </Layout>
  );
};

export default Ultherapy;
